import store from '@/store'
export default [
  {
    path: '/pre-invoices',
    name: 'pre-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pre-invoice/index.vue')
  },
  {
    path: '/pre-invoices/create',
    name: 'pre-invoice-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pre-invoice/create.vue')
  },
  {
    path: '/pre-invoices/:id',
    name: 'pre-invoice-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pre-invoice/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('preInvoice/find', to.params.id)
      next()
    }
  }
]
